// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymodeModal_title__2bmHW","buttons":"PaymodeModal_buttons__2PN9y","contextualModal":"PaymodeModal_contextualModal__2yZnh","chatUpsell":"PaymodeModal_chatUpsell__2pTCQ"};